import { object, date } from 'yup';

export default object().shape({
  leaseEndDate: date()
    .required('Please enter date')
    .typeError('Please enter date'),
  leaseStartDate: date()
    .required('Please correct date')
    .typeError('Please correct date')
});
